import { render, staticRenderFns } from "./CompDiversityChampionsArticleMainCard.vue?vue&type=template&id=7f96bc58&scoped=true"
import script from "./CompDiversityChampionsArticleMainCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompDiversityChampionsArticleMainCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f96bc58",
  null
  
)

export default component.exports